exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_object-gops.js
// module id = ../../../../core-js/library/modules/_object-gops.js
// module chunks = 7